"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Format = void 0;
class Format {
    static currency(value) {
        return new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format(value);
    }
    static percent(value) {
        return Math.min(100, value).toFixed(2) + '%';
    }
    static domNumber(dom, defaultValue = 0) {
        return parseInt(String(dom.val()).replace(/\D/g, '')) || defaultValue;
    }
    static date(date) {
        const months = ['Jan', 'Feb', 'Mrz', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
        let day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        if (day < 10)
            day = '0' + day;
        return `${day}. ${month}. ${year}`;
    }
}
exports.Format = Format;
